import React, { useState } from "react";
import { IoMdClose } from "react-icons/io";
import Lottie from 'lottie-react';
import SuccessLotie from "../../Assets/lottieFiles/success.json";
import NodeaxiosInstance from "../../Services/nodeaxios";
import { showToast } from "../toastConfig/ToastConfig";
import { Razorpay_Key, environment, baseURL } from "../../Services/axios";
import RazorPay from "../razorPay";
import { useCallback } from "react";


const AddPingsOffcanvas = ({ toggleOffcanvas, isOpen }) => {
    const [paymentSuccess, setPaymentSuccess] = useState(false);
    const [selectedOption, setSelectedOption] = useState(null);
    const [pingleAmt, setPingleAmt] = useState(null);
    const [error, setError] = useState(null);
    const [payBtnLoading, setPayBtnLoading] = useState(false);
    const [pageLoaded, setPageLoaded] = useState(false);


    let quickSelectOptions = [
        { id: 1, amt: 100 },
        { id: 2, amt: 500 },
        { id: 3, amt: 1000 },
        { id: 4, amt: 2000 },
        { id: 5, amt: 5000 }];

    const handlepingSelection = (option) => {
        setError(null);
        if (selectedOption == option?.id) {
            setSelectedOption(null);
            setPingleAmt();
        } else {
            setSelectedOption(option?.id);
            setPingleAmt(option?.amt);
        }
    };

    const handleInputChange = (e) => {
        let value = e.target.value;

        if (value.length > 4) return;
        setError(null);
        if (value === '' || (Number(value) >= 0 && Number(value) <= 5000)) {
            setPingleAmt(value);
            setSelectedOption(null);
            setError("");
        } else if (Number(value) > 5000) {
            setError("Maximum amount is 5000");
        } else {
            setError("Please enter a valid number");
        }
    };

    const handelPurchase = async () => {
        // Handle the purchase logic here, such as making an API call to process the payment
        console.log(`Purchasing ${pingleAmt} pings`);

        if (!pingleAmt) {
            setError("Please enter an amount to proceed");
            return;
        }
        setPayBtnLoading(true);

        try {
            let body = {
                pings: pingleAmt,
            }

            let response = await NodeaxiosInstance.post("/wallet/topup-pings", body); 

            if (response.status == 200) {
                let data = response?.data
                handlePayment(data?.userDetails, data?.paymentRecipt)

            }

        } catch (error) {
            setPayBtnLoading(false);

            showToast("Payment failed. Please try again later.")
        }


        // // Simulate payment processing delay
        // setTimeout(() => {
        //     setPayBtnLoading(false);
        //     setPaymentSuccess(true);
        // }, 2000);
        // setTimeout(() => {
        //     setPaymentSuccess(false);
        // }, 5000);
    }

    const loadRazorpayScript = () => {
        return new Promise((resolve) => {
            const script = document.createElement("script");
            script.src = "https://checkout.razorpay.com/v1/checkout.js";
            script.onload = () => resolve(true);
            script.onerror = () => resolve(false);
            document.body.appendChild(script);
        });
    };


    const handlePayment = useCallback((userData, orderData) => {
        setPageLoaded(false);

        const createOrderAndInitializePayment = async () => {

            const isLoaded = await loadRazorpayScript();

            if (!isLoaded) {
                alert("Razorpay SDK failed to load");
                setPageLoaded(true);
                return;
            }

            if (!window.Razorpay) {
                console.error("Razorpay not available");
                return;
            }

            let origin = "";
            if (environment == "TEST" || environment == "PRODUCTION") {
                origin = `${baseURL}payment-completed?order_id=${orderData.id}&type=pingtopup&user_id=${userData?.user_id}`;
            } else {
                origin = `${window.location.origin}/payment-completed?order_id=${orderData.id}&type=pingtopup&user_id=${userData?.user_id}`;
            }


            const options = {
                key: Razorpay_Key,
                amount: orderData?.amount,
                currency: orderData?.currency || "INR",
                name: "PINGLE",
                description: "Payment",
                image: "https://pingle.in/user/assets/images/LogoUser.png",
                order_id: orderData?.id,
                handler: () => {
                    // window.location.href = origin;
                    setPaymentSuccess(true);
                },
                prefill: {
                    name: userData?.user_name,
                    email: userData?.user_email,
                    contact: userData?.user_mbl,
                },
                theme: {
                    color: "#4E26A3",
                },
                modal: {
                    ondismiss: () => {
                        setPageLoaded(true);
                    },
                }
            };

            const razorpay = new window.Razorpay(options);

            razorpay.on("payment.failed", (response) => {
                console.error("Payment Failed:", response.error);
                setPayBtnLoading(true);
                setPageLoaded(true);
            });

            razorpay.open();
        };

        createOrderAndInitializePayment();
    }, []);


    return (
        <>
            {isOpen &&
                <div className={`d-flex justify-content-center ${isOpen ? "modal-backdrop" : ""}`} >
                    <div className={` offcanvas-bottom-modal ${isOpen ? "show" : ""}`}>
                        <div className=" ">
                            <div className="d-flex justify-content-between align-items-center ">
                                <h5 className="modal_seaction_header">Add Pings</h5>
                                <p className=" ff-poppins-regular  fs-20 secondary-text-2 " onClick={toggleOffcanvas}> <IoMdClose /> </p>
                            </div>
                            <div>
                                <input type="text" maxLength={4}
                                    className="ping_input mb-3" value={pingleAmt || ''}
                                    onKeyDown={(e) => {
                                        if (e.key === "Enter") {
                                            e.target.blur();
                                        }
                                    }}
                                    onChange={(e) => {
                                        const value = e.target.value.replace(/\D/g, ""); // allow only numbers
                                        handleInputChange({ target: { value } });
                                    }}
                                    placeholder="Enter pings to add"
                                />
                                <div>
                                    <h5 className='modal_seaction_header'>Quick Select</h5>
                                    <div className='d-flex gap-3 mt-2'>
                                        {
                                            quickSelectOptions.map((option) => (
                                                <span key={option.id} className={`ping_quick_select_btn ${selectedOption === option.id ? "ping_quick_selected_btn" : ""}`}
                                                    onClick={() => handlepingSelection(option)}>
                                                    {option.amt}
                                                </span>
                                            ))
                                        }
                                    </div>
                                </div>
                                <div>
                                    <div className='d-flex justify-content-between mt-3'>
                                        <span className='fs-12 ff-poppins-semiBold'>Amount To Pay   </span>
                                        <span className='ff-poppins-medium primary-text fs-12'>
                                            <span className="rupeeIcon ">&nbsp;₹</span>
                                            {pingleAmt ? pingleAmt : 0} </span>
                                    </div>

                                    {
                                        error && !pingleAmt &&
                                        <span className="inline-error-text ">
                                            {error}
                                        </span>
                                    }
                                    <button
                                        className={`ping_purchese_btn ${!pingleAmt || Number(pingleAmt) === 0 || error ? 'opacity-40' : ''
                                            }`}
                                        disabled={!pingleAmt || Number(pingleAmt) === 0 || !!error}
                                        onClick={() => handelPurchase()}
                                    >
                                        {
                                            payBtnLoading ? (
                                                <>
                                                    <span className="spinner-border spinner-border-sm"></span>
                                                    <span className="visually-hidden">Loading...</span>
                                                </>
                                            ) : (
                                                "Proceed to Pay"
                                            )
                                        }
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            }


            {
                paymentSuccess &&
                <div className="modal show d-flex justify-content-center" style={{ backgroundColor: "#ebebeb", zIndex: "6666" }}>
                    <div className="modal-dialog modal-dialog-centered">
                        <div className="modal-content modal-success ff-poppins-semiBold rounded-4" style={{ width: '80%' }}>
                            <div className="w-100 d-flex justify-content-end p-5">
                                <div className=' d-flex justify-content-center align-items-center'>
                                    <Lottie animationData={SuccessLotie} loop={1} autoPlay={true} />
                                </div>
                            </div>
                            <div className="mt-1 mb-4 text-center fw-bold primary-text">
                                Payment Successfull.
                            </div>
                            <div className="text-center mb-3">
                                <button type="button" className="lottieOkBtn rounded-pill mt-2" onClick={() => { toggleOffcanvas(); setPaymentSuccess(false);}}   >
                                    OK
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            }
        </>
    )
}

export default AddPingsOffcanvas